<script setup>
const stats = [
  { icon: 'cert', figure: 63, description: 'presume a certificate will enhance their job prospects and career advancement' },
  { icon: 'star', figure: 82, description: 'look to certification to validate their skills and knowledge' },
  { icon: 'case', figure: 96, description: 'believe that having a certification will enhance their professional credibility' }
]
</script>

<template>
  <AppContainer class="pt-32 md:pt-40">
    <div class="flex w-full flex-col items-center gap-10 md:gap-15">
      <h2 class="heading-primary mx-auto text-center text-3xl font-bold md:max-w-3xl md:text-[54px] md:leading-tight xl:max-w-5xl">
        Research shows <em>clear interest</em> in achieving certification
      </h2>
      <p class="mx-auto max-w-3xl text-center text-base font-light text-eerie-black md:text-lg dark:text-body-gray">
        We received more than <span class="font-bold text-azure-radiance">2,500 responses</span> from developers in a
        pre-launch survey conducted about the Certification Program.
      </p>
      <div
        class="grid w-full max-w-md gap-10 xl:max-w-full xl:grid-cols-3">
        <div
          v-for="(stat, index) in stats"
          :key="index"
          class="flex w-full flex-col gap-4 rounded-2xl bg-eerie-black/5 p-10 md:gap-5 dark:bg-dark-gunmetal">
          <InlineSvg
            :src="`/images/homepage/benefit-${stat.icon}.svg`"
            class="hidden h-auto w-8 fill-current dark:block"
            :alt="index" />
          <InlineSvg
            :src="`/images/homepage/benefit-${stat.icon}-light.svg`"
            class="h-auto w-8 fill-current dark:hidden"
            :alt="index" />
          <div class="heading-primary text-5xl font-medium">
            <em>{{ stat.figure }}%</em>
          </div>
          <p
            class="tex-base font-light text-eerie-black md:text-lg dark:text-body-gray">
            {{ stat.description }}
          </p>
        </div>
      </div>
      <p class="mx-auto max-w-xl text-center text-base font-light text-eerie-black md:text-lg xl:w-224 dark:text-body-gray">
        Certification can benefit companies with improved team morale, productivity, skills, and efficiency. Recruiting a certified developer also ensures that candidates have the requisite skills!
      </p>
    </div>
  </AppContainer>
</template>
